var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.value, function(question, key) {
      return _c(
        "div",
        {
          key: question.id,
          class: {
            "pt-4": key !== 0 || !_vm.hasDivider,
            "border-bottom pb-5": _vm.hasDivider
          }
        },
        [
          _c(
            "div",
            { staticClass: "font-weight-bold d-flex align-items-center mb-2" },
            [_vm._v(" " + _vm._s(_vm.getTitle(question, key)) + " ")]
          ),
          _c(
            "div",
            [
              _vm.isNumber(question)
                ? _c(
                    "div",
                    { staticClass: "w-25" },
                    [
                      _c("number", {
                        attrs: {
                          "is-preview": _vm.isPreview,
                          "is-read-only": _vm.isReadOnly
                        },
                        model: {
                          value: question.value,
                          callback: function($$v) {
                            _vm.$set(question, "value", $$v)
                          },
                          expression: "question.value"
                        }
                      })
                    ],
                    1
                  )
                : _vm.isTextArea(question)
                ? _c(
                    "div",
                    [
                      _c("custom-text-area", {
                        attrs: {
                          disabled: _vm.isReadOnly,
                          maxlength: 3000,
                          placeholder: "Escribe tu respuesta"
                        },
                        model: {
                          value: question.value,
                          callback: function($$v) {
                            _vm.$set(question, "value", $$v)
                          },
                          expression: "question.value"
                        }
                      })
                    ],
                    1
                  )
                : _vm.isCheckVertical(question)
                ? _c(
                    "div",
                    [
                      _c("checks", {
                        attrs: {
                          "is-read-only": _vm.isReadOnly,
                          options: question.answers
                        },
                        model: {
                          value: question.value,
                          callback: function($$v) {
                            _vm.$set(question, "value", $$v)
                          },
                          expression: "question.value"
                        }
                      })
                    ],
                    1
                  )
                : _vm.isCheckHorizontal(question)
                ? _c(
                    "div",
                    [
                      _c("checks", {
                        attrs: {
                          horizontal: "",
                          "is-read-only": _vm.isReadOnly,
                          options: question.answers
                        },
                        model: {
                          value: question.value,
                          callback: function($$v) {
                            _vm.$set(question, "value", $$v)
                          },
                          expression: "question.value"
                        }
                      })
                    ],
                    1
                  )
                : _vm.isRadioVertical(question)
                ? _c(
                    "div",
                    [
                      _c("radios", {
                        attrs: {
                          "is-read-only": _vm.isReadOnly,
                          options: question.answers
                        },
                        model: {
                          value: question.value,
                          callback: function($$v) {
                            _vm.$set(question, "value", $$v)
                          },
                          expression: "question.value"
                        }
                      })
                    ],
                    1
                  )
                : _vm.isRadioHorizontal(question)
                ? _c(
                    "div",
                    [
                      _c("radios", {
                        attrs: {
                          horizontal: "",
                          "is-read-only": _vm.isReadOnly,
                          options: question.answers
                        },
                        model: {
                          value: question.value,
                          callback: function($$v) {
                            _vm.$set(question, "value", $$v)
                          },
                          expression: "question.value"
                        }
                      })
                    ],
                    1
                  )
                : _vm.isRadioWithLinkedAnswerQuestions(question)
                ? _c(
                    "div",
                    [
                      _c("radios", {
                        attrs: {
                          "is-read-only": _vm.isReadOnly,
                          options: question.answers
                        },
                        model: {
                          value: question.value,
                          callback: function($$v) {
                            _vm.$set(question, "value", $$v)
                          },
                          expression: "question.value"
                        }
                      })
                    ],
                    1
                  )
                : _vm.isDocument(question)
                ? _c(
                    "div",
                    [
                      _vm.isReadOnly
                        ? _c(
                            "div",
                            [
                              _c("label", { staticClass: "data-label" }, [
                                _vm._v(" Archivo ")
                              ]),
                              _c("action-button", {
                                staticClass: "w-100 disabled",
                                attrs: {
                                  disabled: true,
                                  i: "fas fa-file-plus",
                                  text: "Presione aquí para anejar documento",
                                  variant: "outline-grey mr-3 pl-3 pr-4"
                                }
                              })
                            ],
                            1
                          )
                        : _c("validation-provider", {
                            staticClass: "w-100",
                            attrs: { name: "Documento", rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-file-input", {
                                        ref: "fileInput",
                                        refInFor: true,
                                        attrs: {
                                          accept: ".pdf",
                                          "attachment-id": question.Id,
                                          "custom-error-msg":
                                            "documento es requerido",
                                          "display-style": "normal",
                                          error: errors[0],
                                          label: "Archivo",
                                          "label-position": "left",
                                          name: question.documentName,
                                          "on-download": () => {}
                                        },
                                        model: {
                                          value: question.value,
                                          callback: function($$v) {
                                            _vm.$set(question, "value", $$v)
                                          },
                                          expression: "question.value"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                    ],
                    1
                  )
                : _c("div", [_vm._v(" - ")]),
              _vm.showAnswerQuestions(question)
                ? _vm._t("selected-answer-questions", null, {
                    answered: question.value,
                    parent: { question, index: key },
                    questions: _vm.getAnswerQuestions(question)
                  })
                : _vm._e()
            ],
            2
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }